var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLackFirmness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 15,
    viewBox: "0 0 43 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.2557C1 6.2557 3.61702 6.11031 7.97872 7.12804C12.3404 8.14576 16.3532 10.6174 21.9362 10.6174C27.5191 10.6174 30.6596 8.29115 35.0213 7.12804C39.383 5.96492 42 6.2557 42 6.2557",
    stroke: "#283333",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.362C1 12.362 4.46873 12.0497 9.28723 12.6528C12.9796 13.115 17.5745 13.9613 21.9362 13.9613C27.1702 13.9613 29.8727 13.1176 33.7128 12.6528C38.7665 12.0413 42 12.362 42 12.362",
    stroke: "#283333",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.0217C1 1.0217 5.79787 0.749093 8.85106 1.89404C11.9043 3.03899 16.3532 8.12808 21.9362 8.12808C27.5191 8.12808 31.0957 3.20258 35.0213 1.89404C38.9468 0.585503 42 1.0217 42 1.0217",
    stroke: "#283333",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLackFirmness);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCA0MyAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNi4yNTU3QzEgNi4yNTU3IDMuNjE3MDIgNi4xMTAzMSA3Ljk3ODcyIDcuMTI4MDRDMTIuMzQwNCA4LjE0NTc2IDE2LjM1MzIgMTAuNjE3NCAyMS45MzYyIDEwLjYxNzRDMjcuNTE5MSAxMC42MTc0IDMwLjY1OTYgOC4yOTExNSAzNS4wMjEzIDcuMTI4MDRDMzkuMzgzIDUuOTY0OTIgNDIgNi4yNTU3IDQyIDYuMjU1NyIgc3Ryb2tlPSIjMjgzMzMzIiBzdHJva2Utd2lkdGg9IjAuNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMSAxMi4zNjJDMSAxMi4zNjIgNC40Njg3MyAxMi4wNDk3IDkuMjg3MjMgMTIuNjUyOEMxMi45Nzk2IDEzLjExNSAxNy41NzQ1IDEzLjk2MTMgMjEuOTM2MiAxMy45NjEzQzI3LjE3MDIgMTMuOTYxMyAyOS44NzI3IDEzLjExNzYgMzMuNzEyOCAxMi42NTI4QzM4Ljc2NjUgMTIuMDQxMyA0MiAxMi4zNjIgNDIgMTIuMzYyIiBzdHJva2U9IiMyODMzMzMiIHN0cm9rZS13aWR0aD0iMC43NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xIDEuMDIxN0MxIDEuMDIxNyA1Ljc5Nzg3IDAuNzQ5MDkzIDguODUxMDYgMS44OTQwNEMxMS45MDQzIDMuMDM4OTkgMTYuMzUzMiA4LjEyODA4IDIxLjkzNjIgOC4xMjgwOEMyNy41MTkxIDguMTI4MDggMzEuMDk1NyAzLjIwMjU4IDM1LjAyMTMgMS44OTQwNEMzOC45NDY4IDAuNTg1NTAzIDQyIDEuMDIxNyA0MiAxLjAyMTciIHN0cm9rZT0iIzI4MzMzMyIgc3Ryb2tlLXdpZHRoPSIwLjc1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";